.e1{background-color:inherit;}